import { useAdminUserContext, useVoterUserContext } from '@nv/contexts'
import { useTranslation } from 'react-i18next'
import styles from './WelcomeMessage.module.scss'

const WelcomeMessage = () => {
  const { t } = useTranslation()
  const VoterUser = useVoterUserContext().voterUser
  const adminUser = useAdminUserContext().adminUser
  const username = adminUser?.username || VoterUser?.fullName || `${VoterUser?.firstName} ${VoterUser?.lastName}`

  return <span className={styles['welcome-message']}>{t('main.greeting', { name: username })}</span>
}

export default WelcomeMessage
